import { TTextData } from '@libs/types';
import React from 'react';
import { TTextOption } from '../../types/options';
import { TextCommon } from '../UI/Text/TextCommon';
import styles from './styles/textLinked.module.css';
import { getMarkup } from './utils';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

type TTextLinkedProps = {
    options: TTextOption;
    data: TTextData;
    uid?: string;
};
/**
 * @deprecated - we do not support this widget. All this migrated to CoreText
 */
const TextLinked = (props: TTextLinkedProps) => {
    const { options, data, uid } = props;
    const sanitizedHtml = DOMPurify.sanitize(getMarkup(data), {
        ADD_ATTR: ['target'],
    });

    return (
        <div className={styles.textLinkedStyled}>
            <TextCommon isWidget={false} uid={uid} options={options}>
                {parse(sanitizedHtml)}
            </TextCommon>
        </div>
    );
};
export { TextLinked };
